// ES6 Polyfill
import 'core-js/stable';
import 'regenerator-runtime/runtime';

// IE11 Polyfill
import 'focus-within-polyfill';
import smoothscroll from 'smoothscroll-polyfill';

// Lazy Loading
import lazySizes from 'lazysizes';
import 'lazysizes/plugins/bgset/ls.bgset';
import 'lazysizes/plugins/unveilhooks/ls.unveilhooks';
import 'lazysizes/plugins/native-loading/ls.native-loading';
import 'lazysizes/plugins/print/ls.print';

// General
import buttonNavigation from './modules/buttonNavigation';
import parallax from './modules/parallax';
import responsiveNavigation from './modules/responsiveNavigation';
import autoSubmitForm from './modules/autoSubmitForm';
import carousel from './modules/carousel';
import poolieForm from './modules/poolieForm';
import innovationSlider from './modules/innovationSlider';
import productPreviewsSlider from './modules/productPreviewsSlider';
import productSlider from './modules/productSlider';
import smoothAnchorScroll from './modules/smoothAnchorScroll';
import fileUpload from './modules/fileUpload';
import conditionalLogic from './modules/conditionalLogic';
import inputDateTime from './modules/inputDateTime';
import inputNumberMask from './modules/inputNumberMask';
import heroThumbnailImage from './modules/heroThumbnailImage';
import filterWidget from './modules/filterWidget';
import dropdown from './modules/dropdown';
import recaptchFormObserver from './modules/recaptchFormObserver';

lazySizes.cfg.nativeLoading = {
    setLoadingAttribute: true,
    disableListeners: {
        scroll: true,
    },
};

window.onload = () => {
    smoothscroll.polyfill();
    buttonNavigation.init();
    parallax.init();
    responsiveNavigation.init();
    carousel.init();
    autoSubmitForm.init();
    productPreviewsSlider.init();
    innovationSlider.init();
    productSlider.init();
    smoothAnchorScroll.init();
    poolieForm.init();
    conditionalLogic.init();
    fileUpload.init();
    inputDateTime.init();
    inputNumberMask.init();
    heroThumbnailImage();
    filterWidget();
    dropdown();
    recaptchFormObserver.init();
};
